import { useSelector } from 'react-redux';
import { selectExperiment } from '../selectors/config';

export default function useExperiment(experimentKey, defaultValue) {
  return useSelector((state) =>
    selectExperiment(state, experimentKey, defaultValue),
  );
}
